<div class="ranking ranking--square">


<div class="ranking__position">
  <span>{{ rank }}</span>
</div>
<div
  *ngIf="showVariation && (isNew != undefined || isNew != false)"
  class="ranking__status"
  [ngClass]="value | getRankClass"
>
  {{ (isNew == undefined || isNew == false) ? (value | parseRank) : '' }}
  <div class="list-row-item__ranking__arrow new new__margin" *ngIf="isNew">
    {{'NEW' | transloco}}
  </div>

</div>
</div>
